import { handle } from 'redux-pack';
import { Action } from '../../../types/actions';
import { PasscodeList } from '../../../types/working-model';
import {
	ADD_PASSCODE_LIST,
	GET_PASSCODE_LISTS,
} from '../../actions/admin/passcode-lists';

export interface PasscodeListState {
	passcodeLists: PasscodeList[];
}

const initialState: PasscodeListState = {
	passcodeLists: [],
};

export default function PasscodeListReducer(
	state: PasscodeListState = initialState,
	action: Action
): PasscodeListState {
	switch (action.type) {
		case GET_PASSCODE_LISTS: {
			return handle(state, action, {
				success: (state) => ({
					...state,
					passcodeLists: action.payload,
				}),
			});
		}
		case ADD_PASSCODE_LIST: {
			return {
				...state,
				passcodeLists: [...state.passcodeLists, action.payload],
			};
		}
		default:
			return state;
	}
}
